/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { UpdateAssetMutation, UpdateAssetMutationVariables } from "@models/graphql";

const defaultUpdateAssetOptions: MutationHookOptions<UpdateAssetMutation, UpdateAssetMutationVariables> = {};

export const useUpdateAsset = (options?: MutationHookOptions<UpdateAssetMutation, UpdateAssetMutationVariables>) => {
    const [mutation, { data, loading, error }] = useMutation<UpdateAssetMutation, UpdateAssetMutationVariables>(
        GraphQLDocuments.updateAsset
    );

    const updateAsset = async (
        variables: UpdateAssetMutationVariables,
        opts?: MutationHookOptions<UpdateAssetMutation, UpdateAssetMutationVariables>
    ) => {
        try {
            const response = await mutation({
                ...defaultUpdateAssetOptions,
                ...options,
                ...opts,
                variables
            });

            return {
                error: response.errors,
                data: response.data
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        updateAsset
    };
};
